<template>
  <section v-if="sidebarCurrentPanel === 'jump'" class="kp-modular-submenu kp-modular-submenu-tab">
    <div class="kp-modular-tab shadow-tab">
      <header class="kp-modular-title">
        <a href="javascript:;" @click="sidebarChangePanel('steps');" class="klickart-element-back-button" :title="$t('general.actions.back')">
          <i class="fa fa-chevron-left"></i>
        </a>
        {{$t('general.labels.destinations')}}
      </header>
      <div class="submenu-content sub-color">
        <ul id="klickbox-step-list" class="submenu-no-padding scroll-person">
          <li class="kp-list-group-item">
            <div class="kp-row">
              <span>
                <step-icon :step="stepActive"></step-icon>
                {{ stepActive.sanitized_title }}
              </span>
            </div>
          </li>
          <li v-for="(jump, index) in jumpList" class="submenu-padding">
            <add-first-button></add-first-button>
            <div v-if="jump.options_ids">
              <jump-header :index="index" :jump-id="jump.id"></jump-header>
              <multiple-answer-select v-if="stepActive.multiple_answers" :jump="jump"></multiple-answer-select>
              <single-answer-select v-else :jump="jump"></single-answer-select>
              <destiny-select :selected="jump.destination_step_id" :jump="jump"></destiny-select>
            </div>

            <exception-select v-else :selected="jump.destination_step_id" :jump="jump"></exception-select>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import StepIcon from '../Icon.vue';
import AddFirstButton from './buttons/AddFirst.vue';
import JumpHeader from './Header.vue';
import MultipleAnswerSelect from './selects/MultipleAnswer.vue';
import SingleAnswerSelect from './selects/SingleAnswer.vue';
import DestinySelect from './selects/Destiny.vue';
import ExceptionSelect from './selects/Exception.vue';

let listSize = 0;

export default {
  updated() {
    const element = document.querySelector('.submenu-padding:last-of-type');

    if (!this.jumpList) {
      return;
    }

    if (listSize > this.jumpList.length) {
      listSize = this.jumpList.length;
      return;
    }

    if (element) {
      element.scrollIntoView();
    }

    listSize = this.jumpList.length;
  },
  components: {
    StepIcon,
    AddFirstButton,
    JumpHeader,
    MultipleAnswerSelect,
    SingleAnswerSelect,
    DestinySelect,
    ExceptionSelect,
  },
  computed: mapGetters({
    sidebarCurrentPanel: 'sidebarCurrentPanel',
    stepActive: 'stepActive',
    jumpList: 'jumpList',
  }),
  methods: mapActions([
    'sidebarChangePanel',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?18a05e27
 **/